import { useLocation, useNavigate } from "react-router-dom";
import { User, Wallet, Gift } from "lucide-react";
import { useAuth } from "@/context/AuthContext";

export const BottomNav = () => {
  const { user, openAuth, setWalletOpen, walletOpen } = useAuth();
  const nav = useNavigate();
  const { pathname } = useLocation();
  const go = (fn) => () => (user ? fn() : openAuth("login"));

  const items = [
    { id: "profile", label: "Profil", Icon: User, active: pathname === "/profil", onClick: go(() => nav("/profil")) },
    { id: "wallet", label: "Cüzdan", Icon: Wallet, active: walletOpen, onClick: go(() => setWalletOpen(true)) },
    { id: "bonuses", label: "Bonuslar", Icon: Gift, active: pathname === "/bonuslar", onClick: go(() => nav("/bonuslar")) },
  ];

  return (
    <nav className="fixed bottom-0 inset-x-0 z-40 bg-[#1a1d27] border-t border-black/40 pb-[env(safe-area-inset-bottom)]">
      <div className="max-w-xl mx-auto grid grid-cols-3">
        {items.map(({ id, label, Icon, active, onClick }) => (
          <button
            key={id}
            data-testid={`bottom-nav-${id}`}
            onClick={onClick}
            className={`flex flex-col items-center gap-1 py-2.5 text-[12px] font-bold transition-colors ${
              active ? "text-white" : "text-[var(--x-dim)] hover:text-[var(--x-muted)]"
            }`}
          >
            <Icon size={22} strokeWidth={2.2} className={active ? "text-[var(--x-blue)]" : ""} />
            {label}
          </button>
        ))}
      </div>
    </nav>
  );
};
